import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

import Loader from "../../components/Loader";
import { useCommonContext } from "../../utils/context";

const AttendanceLineChart = () => {
  const { attendanceData, isloading } = useCommonContext();

  const chartData = [
    { name: "Present", value: attendanceData?.total_present || 0 },
    { name: "Absent", value: attendanceData?.total_absent || 0 },
    { name: "Idle", value: attendanceData?.total_idle || 0 },
    { name: "On-Leave", value: attendanceData?.total_onleave || 0 },
    { name: "Total", value: attendanceData?.total_users || 0 },
  ];

  return (
    <ResponsiveContainer width="100%" height={320}>
      {isloading.technicians ? (
        <Loader />
      ) : (
        <LineChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fontSize: 14 }} />
          <YAxis tick={{ fontSize: 14 }} domain={["auto", "auto"]} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#ffc107"
            strokeWidth={3}
            dot={{ r: 6 }}
          ></Line>
        </LineChart>
      )}
    </ResponsiveContainer>
  );
};

export default AttendanceLineChart;
